<template>
  <div>
    <Modal :styles="{top: '20px'}" :value="true" title="User Modal" :closable="false" :mask-closable="false">
      <div slot="header" class="d-flex justify-content-between align-items-center">
        <h5>User Form</h5>
        <Button @click="close()" type="text" icon="md-close" class="modal-close-btn"></Button>
      </div>
      <Alert v-if="serverError.length" type="error"> {{serverError}} </Alert>
      <Form class="add-user-modal" ref="addUserForm" :label-width="130" :model="formValidate" :rules="ruleValidate">
        <FormItem :label="$t('user.name_surname')" >
          <Row>
            <Col span="12" style="padding-right: 5px">
              <FormItem prop="firstName">
                <Input v-model="formValidate.firstName" placeholder="Enter Surname..." type="text"/>
              </FormItem>
            </Col>
            <Col span="12" style="padding-left: 5px">
              <FormItem prop="secondName">
                <Input v-model="formValidate.secondName" placeholder="Enter Name..." type="text"/>
              </FormItem>
            </Col>
          </Row>
        </FormItem>

        <FormItem :label="$t('user.form.login')" prop="name">
          <Input v-model="formValidate.name" :readonly="loginInput">
            <Button slot="append" icon="md-create" @click="loginInput = !loginInput"></Button>
          </Input>
        </FormItem>

        <FormItem :label="$t('user.form.geburtsdatum')" prop="birthday">
          <DatePicker v-model="formValidate.birthday" placeholder="Select date" type="date" format="dd.MM.yyyy"></DatePicker>
        </FormItem>

        <FormItem :label="$t('user.email')" prop="email">
          <Input v-model="formValidate.email" placeholder="Enter your e-mail"/>
        </FormItem>

        <FormItem :label="$t('user.form.telefon_funktioniert')" prop="phone">
          <div v-for="(phon, index) in formValidate.phone" :key="'phone-'+index" style="margin-bottom: 5px" class="phone-input-style">
            <Input v-model="formValidate.phone[index]" type="text" placeholder="37312345678" >
              <Button v-if="index > 0" slot="append" @click="removeAdditional('phone', index)" icon="md-remove" class="type-error-btn"></Button>
              <Button v-else slot="append" @click="addAdditional('phone')" icon="md-add" class="type-info-btn"></Button>
            </Input>
          </div>
        </FormItem>

        <FormItem :label="$t('user.form.telefon_personal')" prop="personalPhone">
          <div v-for="(phon, idx) in formValidate.personalPhone" :key="'phone1-'+ idx" style="margin-bottom: 5px" class="phone-input-style">
            <Input v-model="formValidate.personalPhone[idx]" type="text" placeholder="37312345678" >
              <Button v-if="idx > 0" slot="append" @click="removeAdditional('personalPhone', idx)" icon="md-remove" class="type-error-btn"></Button>
              <Button v-else slot="append" @click="addAdditional('personalPhone')" icon="md-add" class="type-info-btn"></Button>
            </Input>
          </div>
        </FormItem>

        <FormItem :label="$t('user.form.bank') + ' IBAN / Swift'" prop="bank">
          <Row>
            <Col span="12" style="padding-right: 5px">
              <Input v-model="formValidate.iban" placeholder="Enter IBAN..." type="text"/>
            </Col>
            <Col span="12" style="padding-left: 5px">
              <Input v-model="formValidate.swift" placeholder="Enter Swift..." type="text"/>
            </Col>
          </Row>
        </FormItem>

        <FormItem :label="$t('user.form.address')" prop="address">
          <Input v-model="formValidate.address" placeholder="Enter Address..." type="text"/>
        </FormItem>

        <FormItem :label="$t('user.form.recruiting')" prop="recruitingDate">
          <DatePicker v-model="formValidate.recruitingDate" placeholder="Select date" type="date" format="dd.MM.yyyy"></DatePicker>
        </FormItem>

        <FormItem :label="$t('user.form.dismissal')" prop="dismissal">
          <DatePicker v-model="formValidate.dismissal" placeholder="Select date" type="date" format="dd.MM.yyyy"></DatePicker>
        </FormItem>

        <FormItem :label="$t('user.form.nationality')" prop="nationality">
          <Input v-model="formValidate.nationality" placeholder="Enter nationality..." type="text"/>
        </FormItem>

        <FormItem :label="$t('user.form.visa')" prop="visa">
          <Row>
            <Col span="12" style="padding-right: 5px">
              <Input v-model="formValidate.visaType" placeholder="Enter Visa Type..." type="text"/>
            </Col>
            <Col span="12" style="padding-left: 5px">
              <DatePicker v-model="formValidate.visaExpiry" placeholder="Select Expiry Visa" type="date" format="dd.MM.yyyy"></DatePicker>
            </Col>
          </Row>
        </FormItem>

        <FormItem :label="$t('user.form.role')" prop="role">
          <Select v-model="formValidate.role" placeholder="Select Role">
              <Option v-for="(item, index) in roles" :value="item.role" :key="item.role + '-' + index">{{ item.title }}</Option>
          </Select>
        </FormItem>

        <FormItem :label="$t('user.password')" prop="password">
          <Input v-model="formValidate.password" type="text">
            <Button slot="append" icon="ios-key" @click="generatePassword()"></Button>
          </Input>
        </FormItem>

        <FormItem :label="$t('invoice.attachment')" prop="userFile">
          <div class="d-flex justify-content-between align-items-center">
            <div v-if="formValidate.files" style="display: inherit">
              <div v-for="(item, index) in formValidate.files" style="position: relative">
                <a @contextmenu.prevent="handler" :href="api_domain + item" :id="'file_' + index" class="mr-1" style="display: inline-block" target="_blank" >
                  <i class="attachment bx bxs-file" style="font-size: 40px"></i>
                </a>
                <ul class="contextMenuDelete">
                  <li @click="deleteFile()">
                    <a><i class="fa-four"></i> {{ $t("global.delete") }}</a>
                  </li>
                </ul>
              </div>
            </div>
            <Upload
              multiple
              ref="upload"
              :show-upload-list="false"
              :on-success="handleSuccess"
              :format="['jpg', 'jpeg', 'png', 'pdf']"
              :max-size="12048"
              :on-format-error="handleFormatError"
              :action="api_domain + 'invoice/attachment'"
            >
              <Button class="upload-file-btn" shape="circle" icon="ios-cloud-upload-outline"></Button>
            </Upload>
          </div>
        </FormItem>

<!--        <FormItem>-->
<!--          <ButtonGroup>-->
<!--            <Button type="error">Заблокировать</Button>-->
<!--            <Button type="warning">Send new password</Button>-->
<!--            <Button type="success">Save</Button>-->
<!--          </ButtonGroup>-->
<!--        </FormItem>-->

<!--        <FormItem>-->
<!--          <Button type="primary" @click="handleSubmit('formValidate')">Submit</Button>-->
<!--          <Button style="margin-left: 8px" @click="handleReset('formValidate')">Reset</Button>-->
<!--        </FormItem>-->
      </Form>
      <div slot="footer" class="text-center">
        <ButtonGroup class="modal-footer-btn">
          <Button v-if="user" @click="banUser()" type="error"><b>{{(formValidate.banned ? 'Разблокировать':'Заблокировать')}}</b></Button>
          <Button v-if="user" @click="sendPassword()" type="warning"><b>Send new password</b></Button>
          <Button @click="handleSubmit('addUserForm')" :loading="loading" type="success"><b>Save<span v-if="!user"> & Send Password</span></b></Button>
        </ButtonGroup>
      </div>
    </Modal>

  </div>
</template>
<script>

export default {
  props: [
    'roles',
    'user'
  ],
  data () {
    return {
      modalUser: false,
      loginInput: true,
      loading: false,
      serverError: '',
      deleteFileIndex: null,
      changes: false,
      formValidate: {
        name: '',
        firstName: '',
        secondName: '',
        phone: [''],
        personalPhone: [''],
        iban: '',
        swift: '',
        email: '',
        birthday: '',
        address: '',
        recruitingDate: '',
        dismissal: '',
        nationality: '',
        visaType: '',
        visaExpiry: '',
        role: '',
        password: '',
        files: []
      },
      ruleValidate: {
        firstName: [
          { required: true, message: 'The name cannot be empty', trigger: 'blur' }
        ],
        secondName: [
          { required: true, message: 'The name cannot be empty', trigger: 'blur' }
        ],
        name: [
          { required: true, message: 'The name cannot be empty', trigger: 'blur' }
        ],
        email: [
          { required: true, message: 'Mailbox cannot be empty', trigger: 'blur' },
          { type: 'email', message: 'Incorrect email format', trigger: 'blur' }
        ],
        birthday: [
          { required: true, type: 'date', message: 'Please select the birthday', trigger: 'change' }
        ],
        recruitingDate: [
          { required: true, type: 'date', message: 'Please select the recruitingDate', trigger: 'change' }
        ],
        nationality: [
          { required: true, message: 'Please enter the nationality', trigger: 'change' }
        ],
        role: [
          { required: true, message: 'Please select gender', trigger: 'change' }
        ],
        password: [
          { required: true, message: 'Please enter a password', trigger: 'blur' },
          { type: 'string', min: 8, message: 'Password to short', trigger: 'blur' }
        ],
        personalPhone: [
          { required: true,
            type: 'array',
            min: 1,
            message: 'Enter minim 1 Phone Number',
            trigger: 'change',
            fields: {
              0: { type: 'string', message: 'Enter minim 1 Phone Number', required: true, min: 4 }
            }
          }
        ]
      }
    }
  },
  watch: {
    formValidate: {
      deep: true,
      handler (value) {
        this.changes = true
        if (this.loginInput) { this.formValidate.name = this.formValidate.firstName + ' ' + this.formValidate.secondName }
      }
    }
  },
  methods: {
    ok () {
      this.$Message.info('Clicked ok')
    },
    close (value) {
      if (this.changes === true) {
        this.$dialog
          .confirm(this.$t('global.changesNotSaved'), {
            okText: this.$t('global.next'),
            cancelText: this.$t('global.exit'),
            customClass: 'mahnung-confirm'
            // reverse: true,
          })
          .then((dialog) => {

          })
          .catch(() => {
            this.$refs['addUserForm'].resetFields()
            this.$emit('close', 0)
          })
      } else {
        this.$refs['addUserForm'].resetFields()
        this.$emit('close', 0)
      }
    },

    handler (event) {
      event.preventDefault()
      const contextMenuDelete = document.querySelector('.contextMenuDelete')
      const [type, id] = event.currentTarget.id.split('_')
      const itemTarget = event.currentTarget
      this.deleteFileIndex = id
      itemTarget.insertAdjacentElement('afterend', contextMenuDelete)
      contextMenuDelete.style.display = 'block'
      document.addEventListener('click', () => {
        contextMenuDelete.style.display = 'none'
      })
    },
    async deleteFile () {
      this.formValidate.files.splice(this.deleteFileIndex, 1)
      this.deleteFileIndex = null
    },
    handleRemove (file) {
      const fileList = this.$refs.upload.fileList
      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1)
    },
    handleSuccess (res, file) {
      this.formValidate['files'].push(res.path)
    },
    handleFormatError (file) {
      this.$Notice.warning({
        title: 'The file format is incorrect',
        desc:
          'File format of ' +
          file.name +
          ' is incorrect, please select jpg or png.'
      })
    },

    handleSubmit (name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          this.loading = true
          await this.submitForm()
          setTimeout(() => {
            this.$emit('close')
          }, 700)
        } else {
          this.$Message.error('Fail!')
        }
      })
    },

    async banUser () {
      await this.$http.post('/user/ban', {
        id: this.formValidate._id,
        banned: (this.formValidate.banned === undefined ? true : !this.formValidate.banned)
      })
      location.reload()
    },
    async sendPassword () {
      if (!this.formValidate.password.length) return

      await this.$http.post('/user/savePassword', {
        id: this.formValidate._id,
        password: this.formValidate.password
      })
      this.$Message.success('Success!')
    },
    async submitForm () {
      this.loading = false
      this.serverError = ''
      let type = 'addNew'
      if (this.user) type = 'editNew'
      try {
        let response = await this.$http.post('/user/' + type, {
          userData: this.formValidate
        })
        if (response.status === 201) {
          if (!this.user) this.$refs['addUserForm'].resetFields()
          this.$emit('updateList', 0)
          this.$Message.success('Success!')
        }
      } catch (e) {
        console.log(e)
        console.log(e.response.data)
        this.serverError = e.response.data.codes[0]
      }
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    },
    addAdditional (phone) {
      this.formValidate[phone].push('')
    },
    removeAdditional (phone, index) {
      this.formValidate[phone].splice(index, 1)
    },
    generatePassword () {
      this.formValidate.password = (Math.random() + 1).toString(36).substring(2)// btoa(Date.now());
    }
  },
  async mounted () {
    if (this.user !== null) {
      const userObj = JSON.parse(JSON.stringify(this.user))

      let obj = {
        ...this.formValidate,
        ...userObj
      }
      obj.role = userObj.role[0]
      obj.password = ''
      this.formValidate = obj
      this.loginInput = false
      delete this.ruleValidate.password
      this.formValidate.birthday = new Date(this.formValidate.birthday)
      this.formValidate.dismissal = new Date(this.formValidate.dismissal)
      this.formValidate.recruitingDate = new Date(this.formValidate.recruitingDate)
      this.formValidate.visaExpiry = new Date(this.formValidate.visaExpiry)
      setTimeout(() => { this.changes = false }, 1000)
    }
    // this.formValidate.roles = this.roles;
  }
}
</script>

<style scoped>
/*.add-user-modal:global(.ivu-form .ivu-form-item) {*/
/*  margin-bottom: 10px !important;*/
/*}*/

.modal-footer-btn button {
  min-width: 150px;
}

ul.contextMenuDelete {
  display: none;
  z-index: 999;
  list-style: none;
  margin: 0;
  padding: 0;
  font: 300 15px "Roboto", sans-serif;
  position: absolute;
  right: 15px;
  color: #333;
  -webkit-box-shadow: 0 12px 15px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 12px 15px 0 rgba(0, 0, 0, 0.2);
}

ul.contextMenuDelete * {
  -webkit-transition: color 0.4s, background 0.4s;
  -o-transition: color 0.4s, background 0.4s;
  transition: color 0.4s, background 0.4s;
}

ul.contextMenuDelete li {
  overflow: hidden;
  white-space: nowrap;
  padding: 12px 30px;
  background-color: #fff;
  border-bottom: 1px solid #ecf0f1;
  cursor: pointer;
  text-align: center;
}

ul.contextMenuDelete li a {
  color: #333;
  text-decoration: none;
}

ul.contextMenuDelete li:hover {
  background-color: #ecf0f1;
}

ul.contextMenuDelete li i {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 10px;
}

ul.contextMenuDelete li .fa-one {
  background: #ddfbe4;
}

ul.contextMenuDelete li .fa-zero {
  background: #f0f0f0;
}

ul.contextMenuDelete li .fa-two {
  background: #00a5e4;
}

ul.contextMenuDelete li .fa-three {
  background: #f0f0f0;
}

ul.contextMenuDelete li .fa-four {
  background: #f59191;
}

.phone-input-style .type-error-btn,
.phone-input-style .type-info-btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  color: #ffffff;
  padding: 5px 15px;
}

.phone-input-style .type-error-btn {
  background-color: #EE4014;
}

.phone-input-style .type-info-btn {
  background-color: #2DB7F6;
}

.add-user-modal :global(.ivu-form-item) {
  margin-bottom: 15px;
}

.add-user-modal ul.contextMenuDelete {
  right: -50px;
  top: 35px;
}

.modal-close-btn {
  padding: 0 5px;
  font-size: 20px;
}

.upload-file-btn :global(.ivu-icon) {
  color: #2DB7F7;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/user/UsersAddFormUser.vue